module.exports = __webpack_public_path__ + "img/mind_skeleton_time_4.32bb06e2.png";